/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfPlatformModeDto } from '../../models/platform-api-result-of-platform-mode-dto';
import { PlatformSetPlatformMode } from '../../models/platform-set-platform-mode';

export interface PostPlatformModeActionSet$Params {
      body: PlatformSetPlatformMode
}

export function postPlatformModeActionSet(http: HttpClient, rootUrl: string, params: PostPlatformModeActionSet$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfPlatformModeDto>> {
  const rb = new RequestBuilder(rootUrl, postPlatformModeActionSet.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfPlatformModeDto>;
    })
  );
}

postPlatformModeActionSet.PATH = '/api/platform-mode/action/set';
